.content {
  padding-top: $panel-top-padding;
}
